import React from "react";

const TexadaChevron = ({ className = "" }) => (
  <svg
    width="360"
    height="360"
    viewBox="0 0 360 360"
    fill="none"
    className={`svg-icon ${className || ""}`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M225.464 59.9397C222.876 105.536 205.804 147.258 178.776 180.575L45.904 350.644C42.9336 354.446 45.6426 360 50.4673 360H174.002C176.972 360 179.778 358.632 181.607 356.291L312.339 188.961C316.431 183.723 316.431 176.372 312.339 171.135L225.464 59.9397Z"
      fill="white"
    />
    <path
      d="M163.786 160.332C179.761 136.583 189.083 107.986 189.083 77.2113C189.083 48.9483 181.22 22.5217 167.562 0H50.3934C45.5687 0 42.8597 5.55417 45.8301 9.35612L163.786 160.332Z"
      fill="#FCCB30"
    />
  </svg>
);

export default TexadaChevron;
